import {
  GetPointOfSaleListQueryVariables,
  Segment,
  SegmentType,
  SortOrder,
  UserLocationInput,
} from "../../../gql/hooks";
import { ProductDataDetails } from "../../../pages/PosList/partials/posfilters/partials/ProductPaneCommon/utils/types";

export type SortType = SortOrder | null;

/** The filters the /pos panel holds, and the only input buildQueryVariables takes. */
export type PosFilters = {
  search: string;
  isOwner?: boolean;
  isActive?: boolean;
  underContract?: boolean;
  brandIds: number[];
  laLiga?: boolean;
  lastVisitDate?: LastVisitOptions;
  missingProducts: ProductDataDetails[];
  existingProducts: ProductDataDetails[];
  rentabilibar?: boolean;
  segments: Segment[];
  segmentTypes: SegmentType[];
  clientType?: ClientTypeType[];
  postalCodes?: string[];
  volumeRange?: [number, number];
};
export type ClientTypeType =
  | "client"
  | "client_no_barril"
  | "client_competitor"
  | "no_client"
  | undefined;

export type SetMissingProductsParams = {
  missingProducts: ProductDataDetails[];
};

export type SetExistingProductsParams = {
  existingProducts: ProductDataDetails[];
};

export type SetSearchParams = {
  search: string;
};

export type SetIsOwnerParams = {
  isOwner: boolean;
};

export type SetUnderContractParams = {
  underContract?: boolean;
};

export type SetActicityStatusParams = {
  isActive?: boolean;
};

export type SetBrandIdsParams = {
  brandIds: number[];
};

export type SetMapLocationParams = {
  location?: {
    latitude: {
      gte: number;
      lte: number;
    };
    longitude: {
      gte: number;
      lte: number;
    };
  };
};

export type SetLaLigaParams = {
  laLiga?: boolean;
};

export type SetRentabilibarParams = {
  rentabilibar?: boolean;
};

export type SetSegmentsParams = {
  segments: Segment[];
};

export type SetClientTypeParams = {
  clientType: ClientTypeType[];
};

export type SetSegmentTypesParams = {
  segmentTypes: SegmentType[];
};

export type SetUserLocationParams = {
  userLocation?: UserLocationInput;
  sortBy: SortType;
};

export type SetQueryVariablesParams = {
  variables: GetPointOfSaleListQueryVariables;
};

export enum LastVisitOptions {
  LAST_30_DAYS = "last_30_days",
  LAST_60_DAYS = "last_60_days",
  LAST_90_DAYS = "last_90_days",
  LAST_180_DAYS = "last_180_days",
  LAST_YEAR = "last_year",
  CURRENT_YEAR = "current_year",
}

export type SetLastVisitDateParams = {
  lastVisitDate?: LastVisitOptions;
};
